"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTherapyPriceNickname = exports.prettifyCents = exports.parsePriceNumToFormString = exports.parsePriceFormStringToNum = exports.hasPriceDiscount = exports.getTherapyPlanPriceByNickName = exports.getIntervalText = exports.getBookingDepositPrice = exports.formatPrice = exports.formatDiscountPrice = exports.PRICE_NICKNAME = void 0;
var _lodash = require("lodash");
// Should be kept in sync with nickname values in Stripe
var PRICE_NICKNAME = {
  CORE_MEMBERSHIP: 'Core Plan',
  BIWEEKLY_THERAPY: 'Bi-Weekly',
  WEEKLY_THERAPY: 'Monthly',
  MEDICATION: 'Medication-assisted treatment'
};
exports.PRICE_NICKNAME = PRICE_NICKNAME;
var renderTherapyPriceNickname = function renderTherapyPriceNickname(therapySubscription) {
  var _therapySubscription$;
  var nickname = therapySubscription.title || ((_therapySubscription$ = therapySubscription.subscription) === null || _therapySubscription$ === void 0 ? void 0 : _therapySubscription$.plan.nickname);
  return nickname === PRICE_NICKNAME.WEEKLY_THERAPY ? 'Weekly' : 'Bi-Weekly';
};
exports.renderTherapyPriceNickname = renderTherapyPriceNickname;
var FREE_PRICE = 'Free';
var formatPrice = function formatPrice(price) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _lodash.defaults)(options, {
    fromCents: false,
    toFixed: true,
    addTaxonomy: true,
    fractionDigits: 2
  });
  var fromCents = options.fromCents,
    toFixed = options.toFixed,
    addTaxonomy = options.addTaxonomy,
    fractionDigits = options.fractionDigits;
  var numValue = (0, _lodash.isNumber)(price) ? price : parseFloat(price || 0);
  numValue = Math.abs(numValue);
  if (fromCents) {
    numValue = numValue / 100;
  }
  var formattedPrice;
  if (toFixed) {
    formattedPrice = numValue.toFixed(fractionDigits);
  }
  formattedPrice = "".concat(addTaxonomy ? '$' : '').concat(formattedPrice || numValue);
  return numValue < 0 ? "-".concat(formattedPrice) : formattedPrice;
};
exports.formatPrice = formatPrice;
var formatDiscountPrice = function formatDiscountPrice(price) {
  return price === 0 ? FREE_PRICE : formatPrice(price, {
    fromCents: true,
    addTaxonomy: false
  });
};
exports.formatDiscountPrice = formatDiscountPrice;
var prettifyCents = function prettifyCents(price) {
  return formatPrice(price, {
    fromCents: true
  });
};
exports.prettifyCents = prettifyCents;
var getIntervalText = function getIntervalText(interval) {
  var price = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return interval ? "$".concat(price, "/").concat(interval) : "$".concat(price);
};
exports.getIntervalText = getIntervalText;
var parsePriceNumToFormString = function parsePriceNumToFormString(rate) {
  return "".concat(parseFloat(rate / 100).toFixed(2));
}; // 5450 => 54.50
exports.parsePriceNumToFormString = parsePriceNumToFormString;
var parsePriceFormStringToNum = function parsePriceFormStringToNum(value) {
  var rate = value.replace('$', ''); // '$54.50' => '54.50'
  return rate.includes('.') ? parseInt(rate.replace('.', '')) : parseInt(rate) * 100; // '54.50' => 5450
};
exports.parsePriceFormStringToNum = parsePriceFormStringToNum;
var hasPriceDiscount = function hasPriceDiscount(price, discountPrice) {
  return (0, _lodash.isNumber)(discountPrice) && price !== discountPrice;
};
exports.hasPriceDiscount = hasPriceDiscount;
var getTherapyPlanPriceByNickName = function getTherapyPlanPriceByNickName(planNickname, prices) {
  if (!planNickname || (0, _lodash.isEmpty)(prices)) {
    return;
  }
  return planNickname === PRICE_NICKNAME.WEEKLY_THERAPY ? prices === null || prices === void 0 ? void 0 : prices.weeklyTherapyPlanPrice : prices === null || prices === void 0 ? void 0 : prices.biweeklyTherapyPlanPrice;
};
exports.getTherapyPlanPriceByNickName = getTherapyPlanPriceByNickName;
var getBookingDepositPrice = function getBookingDepositPrice(_ref) {
  var isEligibleInsurance = _ref.isEligibleInsurance,
    isOriginalMedicare = _ref.isOriginalMedicare;
  if (!isEligibleInsurance) {
    return process.env.REACT_APP_CASHPAY_APPOINTMENT_FIXED_PRICE;
  }
  if (isOriginalMedicare) {
    return process.env.REACT_APP_ORIGINAL_MEDICARE_INSURANCE_FIXED_PRICE;
  }
  return process.env.REACT_APP_INSURANCE_APPOINTMENT_FIXED_PRICE;
};
exports.getBookingDepositPrice = getBookingDepositPrice;